import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  cross_product_tab_label: {
    id: 'product_search_dialog.cross_product.tab_label',
    defaultMessage: 'All',
    description: 'Label to display for the Cross Product search tab'
  },
  cross_product_expanded_input_placeholder: {
    id: 'product_search_dialog.cross_product.expanded.input-placeholder',
    defaultMessage: 'Search All',
    description: 'The placeholder which is visible to the user when Cross Product tab is active '
  },
  cross_product_recents_section_heading: {
    id: 'product_search_dialog.cross_product.recents.section_heading',
    defaultMessage: 'Recently viewed',
    description: 'The heading to display for the Cross Product recents section'
  },
  cross_product_results_section_heading: {
    id: 'product_search_dialog.cross_product.results.section_heading',
    defaultMessage: 'Search results',
    description: 'The heading to display for the Cross Product results section'
  },
  googleDocsLabel: {
    id: 'document-search-result.google-docs-label',
    defaultMessage: 'Docs',
    description: 'Google Docs subtype label'
  },
  googleSlidesLabel: {
    id: 'document-search-result.google-slides-label',
    defaultMessage: 'Slides',
    description: 'Google Slides subtype label'
  },
  googleSheetsLabel: {
    id: 'document-search-result.google-sheets-label',
    defaultMessage: 'Sheets',
    description: 'Google Sheets subtype label'
  },
  msWordLabel: {
    id: 'document-search-result.ms-word-label',
    defaultMessage: 'Word',
    description: 'Microsoft Word subtype label'
  },
  msPowerpointLabel: {
    id: 'document-search-result.ms-powerpoint-label',
    defaultMessage: 'PowerPoint',
    description: 'Microsoft PowerPoint subtype label'
  },
  msExcelLabel: {
    id: 'document-search-result.ms-excel-label',
    defaultMessage: 'Excel',
    description: 'Microsoft Excel subtype label'
  },
  cross_product_empty_state_body: {
    id: 'product_search_dialog.cross_product.empty.no_results_body',
    defaultMessage: '<a>Search all content across your organization</a> or try a different term.',
    description: ''
  }
});